import React from 'react';
import './style.css';

export default ({children, className}) => (
    <div className={className}>
        {group(children).map((row, i) => (
            <div key={i} className="GridLayout-row">
                {row.map((col, i) => <div className="GridLayout-col" key={i}>{col}</div>)}
            </div>
        ))}
    </div>
);

function group(children) {
    if (!Array.isArray(children)) {
        children = [children];
    }
    children = children.filter(child => child !== null);
    const groups = [];
    let currentGroup;
    for (let i = 0; i < children.length; ++i) {
        if (i % 3 === 0) {
            currentGroup = [];
            groups.push(currentGroup);
        }
        currentGroup.push(children[i]);
    }
    return groups;
}


// WEBPACK FOOTER //
// ./src/common/GridLayout/index.js